// 获取浏览器默认语言
export const getBrowserLang = function() {
  let browserLang = navigator.language
    ? navigator.language
    : navigator.browserLanguage;
  let defaultBrowserLang = "";
  if (
    browserLang.toLowerCase() === "us" ||
    browserLang.toLowerCase() === "en" ||
    browserLang.toLowerCase() === "en_us" ||
    browserLang.toLowerCase() === "en-us"
  ) {
    defaultBrowserLang = "en";
  } else {
    defaultBrowserLang = "zn";
  }
  console.log(defaultBrowserLang,'lang')
  return defaultBrowserLang;
};



// WEBPACK FOOTER //
// ./src/utils/checkLang.js